<template>
	<div v-html="html"></div>
</template>

<script>
export default {
	data() {
		return {
			html: '',
		}
	},
	mounted() {
		this.getbannerDetail()
	},
	methods: {
		getbannerDetail() {
			let self = this
			const { bannerId } = self.$route.query
			self.vaxios.get(`${self.vaxios.host}/open/api/v1/banners/${bannerId}/details`, { bannerId }, (res) => {
				if (res === -1 || !res.data) return
				self.html = res.data.content || ''
			})
		},
	},
}
</script>

<style scoped>
html,
body {
	margin: 0;
	padding: 0;
}
body {
	width: 100%;
	height: 100%;
	height: 100vh;
	background: #fff;
	padding: 10px;
	box-sizing: border-box;
}
img {
	max-width: 100%;
}
a {
	word-wrap: break-word;
}
</style>
